module.exports = __webpack_public_path__ + "img/LogoAruba_Color.37f83fad.png";